/* assets/design-vault-rail.js */
(function () {
  const SEL = {
    section: ".vdt",
    tab: ".vdt__tab",
    pane: ".vdt__pane",
    status: ".vdt__statusText"
  };

  const DAY_MS = 24 * 60 * 60 * 1000;

  const safe = (s) => (s || "").toString().replace(/</g, "&lt;").replace(/>/g, "&gt;");
  const strip = (s) => (s || "").toString().trim();

  function seededRand(seedStr) {
    let h = 2166136261;
    for (let i = 0; i < seedStr.length; i++) h = (h ^ seedStr.charCodeAt(i)) * 16777619;
    return function () {
      h += h << 13; h ^= h >>> 7; h += h << 3; h ^= h >>> 17; h += h << 5;
      return ((h >>> 0) / 4294967296);
    };
  }

  function periodKey(mode) {
    const now = new Date();
    if (mode === "weekly") {
      const y = now.getFullYear();
      const first = new Date(y, 0, 1);
      const week = Math.floor(((now - first) / DAY_MS + first.getDay()) / 7);
      return `${y}-W${week}`;
    }
    return now.toISOString().slice(0, 10);
  }

  function setStatus(section, msg) {
    const el = section.querySelector(SEL.status);
    if (el) el.textContent = msg || "";
  }

  function activateTab(section, tabName) {
    section.querySelectorAll(SEL.tab).forEach(btn => {
      const on = btn.dataset.tab === tabName;
      btn.classList.toggle("is-active", on);
      btn.setAttribute("aria-selected", on ? "true" : "false");
    });
    section.querySelectorAll(SEL.pane).forEach(p => {
      p.classList.toggle("is-active", p.dataset.pane === tabName);
    });
  }

  function parseTags(str) {
    return (str || "")
      .split(",")
      .map(s => s.trim().toLowerCase())
      .filter(Boolean);
  }

  function normalizeArticle(a) {
    const tags = Array.isArray(a.tags) ? a.tags.map(t => (t || "").toString().toLowerCase()) : [];
    return {
      id: a.id,
      title: a.title || "Article",
      url: a.url || "#",
      published_at: a.published_at || "",
      tags,
      excerpt: a.excerpt || "",
      image: a.image || ""
    };
  }

  function seededShuffle(arr, rnd) {
    const a = arr.slice();
    for (let i = a.length - 1; i > 0; i--) {
      const j = Math.floor(rnd() * (i + 1));
      [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
  }

  function getPromo(section) {
    const sid = section.getAttribute("data-section-id");
    const el = document.getElementById(`vdt-promo-${sid}`);
    if (!el) return { mode: "fill", max: 2, refresh: "daily", defaultCta: "Explore", embedSafe: true, items: [] };
    try {
      const parsed = JSON.parse(el.textContent || "{}");
      parsed.items = Array.isArray(parsed.items) ? parsed.items : [];
      return parsed;
    } catch {
      return { mode: "fill", max: 2, refresh: "daily", defaultCta: "Explore", embedSafe: true, items: [] };
    }
  }

  async function fetchAllArticles(blogHandle) {
    const cacheKey = `vdt_v9_all_${blogHandle}`;
    const refresh = periodKey("daily");

    try {
      const raw = sessionStorage.getItem(cacheKey);
      if (raw) {
        const parsed = JSON.parse(raw);
        if (parsed && parsed.refresh === refresh && Array.isArray(parsed.articles)) return parsed.articles;
      }
    } catch (_) {}

    const out = [];
    const MAX_PAGES = 12;

    for (let page = 1; page <= MAX_PAGES; page++) {
      const url = `/blogs/${encodeURIComponent(blogHandle)}?view=vdt.json&page=${page}`;
      const res = await fetch(url, { credentials: "same-origin" });
      if (!res.ok) break;

      const json = await res.json();
      const items = Array.isArray(json.articles) ? json.articles : [];
      out.push(...items);

      if (!json.has_next || items.length === 0) break;
    }

    try { sessionStorage.setItem(cacheKey, JSON.stringify({ refresh, articles: out })); } catch (_) {}
    return out;
  }

  async function fetchTaggedArticles(blogHandle, tag) {
    const cleanTag = strip(tag || "").toLowerCase();
    if (!blogHandle || !cleanTag) return [];
    const refresh = periodKey("daily");
    const cacheKey = `vdt_v9_tag_${blogHandle}_${cleanTag}`;

    try {
      const raw = sessionStorage.getItem(cacheKey);
      if (raw) {
        const parsed = JSON.parse(raw);
        if (parsed && parsed.refresh === refresh && Array.isArray(parsed.articles)) return parsed.articles;
      }
    } catch (_) {}

    try {
      const url = `/blogs/${encodeURIComponent(blogHandle)}/tagged/${encodeURIComponent(cleanTag)}?view=vdt.json&page=1`;
      const res = await fetch(url, { credentials: "same-origin" });
      if (!res.ok) return [];
      const json = await res.json();
      const articles = Array.isArray(json.articles) ? json.articles.map(normalizeArticle).filter(a => a.url && a.title) : [];
      try { sessionStorage.setItem(cacheKey, JSON.stringify({ refresh, articles })); } catch (_) {}
      return articles;
    } catch (_) {
      return [];
    }
  }

  function chipLinksBlogTaggedHTML(section, a, maxChips = 3) {
    const blogHandle = section.getAttribute("data-blog-handle") || "";
    const tags = (a.tags || []).slice(0, maxChips);
    if (!tags.length || !blogHandle) return "";
    return `
      <div class="vdt__chips">
        ${tags.map(t => {
          const href = `/blogs/${encodeURIComponent(blogHandle)}/tagged/${encodeURIComponent(t)}`;
          return `<a class="vdt__chipLink" href="${safe(href)}">#${safe(t)}</a>`;
        }).join("")}
      </div>
    `;
  }

  function splitLines(str) {
    return (str || "")
      .split(/\n+/)
      .map(s => s.trim())
      .filter(Boolean);
  }

  const BUILT_IN_FEATURE_NOTES = [
    "The kind of piece that earns the lead slot: useful, polished, and worth opening before the scroll continues.",
    "A smart first read for this rotation—specific enough to be useful, broad enough to belong in the vault.",
    "Selected as the anchor story because it gives this section a stronger point of view, not just another thumbnail.",
    "Start here: this is the editorial north star for today’s mix, with the rest of the rack orbiting around it.",
    "A lead story with enough texture to set the tone and enough utility to justify the click.",
    "This one gets the feature treatment because it feels timely, readable, and distinctly Volarre.",
    "A polished entry point into the section—less filler, more signal.",
    "The featured file for readers who want the best starting point, not the loudest card on the page.",
    "A main-stage read chosen to give this tab shape, rhythm, and editorial intent.",
    "The anchor piece in this set: designed to pull the eye first and reward the click."
  ];

  function featureStatementFor(section, a, tabKey, tabLabelText) {
    const override = splitLines(section.getAttribute(`data-feature-notes-${tabKey}`) || "");
    const pool = override.length ? override : BUILT_IN_FEATURE_NOTES;
    const seed = `${section.getAttribute("data-section-id") || "vdt"}::${tabKey}::${a.id || a.url || a.title || "feature"}`;
    const rnd = seededRand(seed);
    return pool[Math.floor(rnd() * pool.length)] || `A featured ${tabLabelText.toLowerCase()} read selected to anchor this rotation.`;
  }

  function featureTileHTML(section, a, tabLabelText, tabKey) {
    const chips = chipLinksBlogTaggedHTML(section, a, 3);
    return `
      <article class="vdt__tile vdt__tile--feature">
        <a class="vdt__tileLink" href="${safe(a.url)}" aria-label="${safe(a.title)}"></a>
        <div class="vdt__media vdt__media--feature">
          ${a.image ? `<img class="vdt__img" loading="lazy" decoding="async" src="${safe(a.image)}" alt="${safe(a.title)}">` : `<div class="vdt__img vdt__img--empty"></div>`}
          <div class="vdt__pick">Volarre Pick</div>
        </div>
        <div class="vdt__body">
          <div class="vdt__meta"><span class="vdt__metaDept">${safe(tabLabelText)}</span><span class="vdt__dot">•</span><span class="vdt__metaDate">${safe(a.published_at)}</span></div>
          <h3 class="vdt__name"><a class="vdt__nameLink" href="${safe(a.url)}">${safe(a.title)}</a></h3>
          <p class="vdt__desc">${safe(a.excerpt)}</p>
          <div class="vdt__featureStatement">
            <span class="vdt__featureStatementLabel">Editor’s file</span>
            <span class="vdt__featureStatementText">${safe(featureStatementFor(section, a, tabKey || tabLabelText.toLowerCase(), tabLabelText))}</span>
          </div>
          ${chips}
          <div class="vdt__actions">
            <a class="vdt__btn vdt__btn--primary" href="${safe(a.url)}" rel="noopener">Read <span aria-hidden="true">→</span></a>
          </div>
        </div>
      </article>
    `;
  }

  function rackTileHTML(section, a, tabLabelText) {
    const chip = chipLinksBlogTaggedHTML(section, a, 1);
    return `
      <article class="vdt__tile vdt__tile--rack">
        <a class="vdt__tileLink" href="${safe(a.url)}" aria-label="${safe(a.title)}"></a>
        <div class="vdt__media">
          ${a.image ? `<img class="vdt__img" loading="lazy" decoding="async" src="${safe(a.image)}" alt="${safe(a.title)}">` : `<div class="vdt__img vdt__img--empty"></div>`}
        </div>
        <div class="vdt__body">
          <div class="vdt__meta"><span class="vdt__metaDept">${safe(tabLabelText)}</span><span class="vdt__dot">•</span><span class="vdt__metaDate">${safe(a.published_at)}</span></div>
          <h3 class="vdt__name"><a class="vdt__nameLink" href="${safe(a.url)}">${safe(a.title)}</a></h3>
          ${chip}
        </div>
      </article>
    `;
  }

  function endcapUrlForTab(section, tabKey) {
    const explicit = strip(section.getAttribute(`data-endcap-url-${tabKey}`) || "");
    if (explicit) return explicit;

    const blogHandle = section.getAttribute("data-blog-handle") || "";
    const endcapTag = strip(section.getAttribute(`data-endcap-tag-${tabKey}`) || "");
    if (blogHandle && endcapTag) return `/blogs/${encodeURIComponent(blogHandle)}/tagged/${encodeURIComponent(endcapTag.toLowerCase())}`;

    return moreUrlForTab(section, tabKey) || (blogHandle ? `/blogs/${encodeURIComponent(blogHandle)}` : "#");
  }

  function endcapTagForTab(section, tabKey) {
    return strip(section.getAttribute(`data-endcap-tag-${tabKey}`) || section.getAttribute(`data-moretag-${tabKey}`) || "").toLowerCase();
  }

  function vaultEndcapHTML(section, tabKey, tabLabelText, span) {
    const href = endcapUrlForTab(section, tabKey);
    const label = tabLabelText || "Vault";
    const tag = endcapTagForTab(section, tabKey);
    const fallbackTitle = `More ${label}, without the filler.`;
    const fallbackCopyPool = [
      "A curated route deeper into this section, built to close the grid like an editorial page instead of a leftover slot.",
      "The next layer of the archive: cleaner rhythm, stronger discovery, and no dead-space filler.",
      "A compact doorway into the rest of the file for readers who want one more useful branch."
    ];
    const seed = `${section.getAttribute("data-section-id") || "vdt"}::${tabKey}::endcap::${span}`;
    const rnd = seededRand(seed);
    const fallbackCopy = fallbackCopyPool[Math.floor(rnd() * fallbackCopyPool.length)] || fallbackCopyPool[0];
    const title = strip(section.getAttribute(`data-endcap-title-${tabKey}`) || "") || fallbackTitle;
    const copy = strip(section.getAttribute(`data-endcap-copy-${tabKey}`) || "") || fallbackCopy;
    const cta = tag ? `More #${tag}` : `More ${label}`;

    return `
      <aside class="vdt__vaultEndcap" style="--vdt-endcap-span:${span}" aria-label="${safe(cta)}" data-endcap-card="1" data-endcap-tag="${safe(tag)}" data-endcap-url="${safe(href)}">
        <div class="vdt__vaultEndcapMain">
          <div class="vdt__vaultEndcapKicker">Continue the file${tag ? ` · #${safe(tag)}` : ``}</div>
          <div class="vdt__vaultEndcapTitle">${safe(title)}</div>
          <div class="vdt__vaultEndcapCopy">${safe(copy)}</div>
          <div class="vdt__vaultEndcapPreview" data-endcap-preview="1">
            ${tag ? `<span class="vdt__vaultEndcapLoading">Checking the tagged file…</span>` : `<span class="vdt__vaultEndcapLoading">Set an endcap tag or URL in Customize.</span>`}
          </div>
        </div>
        ${href && href !== "#" ? `<a class="vdt__btn vdt__btn--primary vdt__vaultEndcapAction" href="${safe(href)}">${safe(cta)} <span aria-hidden="true">→</span></a>` : ``}
      </aside>
    `;
  }

  function wireEndcaps(section, root) {
    const blogHandle = section.getAttribute("data-blog-handle") || "";
    root.querySelectorAll('[data-endcap-card="1"]').forEach(card => {
      const tag = strip(card.getAttribute("data-endcap-tag") || "");
      const preview = card.querySelector('[data-endcap-preview="1"]');
      if (!blogHandle || !tag || !preview || card.dataset.endcapWired === "1") return;
      card.dataset.endcapWired = "1";

      fetchTaggedArticles(blogHandle, tag).then(articles => {
        const first = articles[0];
        const count = articles.length;
        if (!first) {
          preview.innerHTML = `<span class="vdt__vaultEndcapLoading">No published stories found under #${safe(tag)} yet.</span>`;
          return;
        }
        preview.innerHTML = `
          <a class="vdt__vaultEndcapStory" href="${safe(first.url)}">
            ${first.image ? `<img class="vdt__vaultEndcapThumb" src="${safe(first.image)}" alt="${safe(first.title)}" loading="lazy" decoding="async">` : ``}
            <span class="vdt__vaultEndcapStoryText">
              <span class="vdt__vaultEndcapStoryLabel">${count} tagged ${count === 1 ? "story" : "stories"}</span>
              <span class="vdt__vaultEndcapStoryTitle">${safe(first.title)}</span>
            </span>
          </a>
        `;
      }).catch(() => {
        preview.innerHTML = `<span class="vdt__vaultEndcapLoading">Tagged file link is ready.</span>`;
      });
    });
  }

  // PROMOS — return ALL applicable promos (no overriding)
  function promosForTab(section, promoData, tabKey) {
    const items = Array.isArray(promoData.items) ? promoData.items : [];
    if (!items.length) return [];
    const scoped = items.filter(it => it && (it.tab === "all" || it.tab === tabKey));

    const usable = scoped.filter(it => {
      if (it.type === "image") return !!it.image;
      if (it.type === "video_hosted") return Array.isArray(it.sources) && it.sources.some(s => s && s.url);
      if (it.type === "video_url") return !!it.video_url;
      if (it.type === "product") return !!(it.product && it.product.url);
      if (it.type === "ext") return !!(it.url && it.image);
      if (it.type === "ad") return !!it.embed;
      return false;
    });

    if (!usable.length) return [];

    const key = periodKey(promoData.refresh || "daily");
    const seed = `${key}::${section.getAttribute("data-section-id")}::promo::${tabKey}`;
    const rnd = seededRand(seed);
    return seededShuffle(usable, rnd);
  }

  function promoCardInnerHTML(section, item, fallbackCta) {
    const cta = strip(item.cta) || fallbackCta || "Explore";
    const heading = strip(item.heading) || "Spotlight";
    const sub = strip(item.sub) || "";
    const link = strip(item.link) || "";

    if (item.type === "video_hosted") {
      const autoplay = item.autoplay ? "autoplay" : "";
      const muted = item.mute ? "muted" : "";
      const loop = item.loop ? "loop" : "";
      const sources = (Array.isArray(item.sources) ? item.sources : [])
        .filter(s => s && s.url)
        .map(s => `<source src="${safe(s.url)}" type="${safe(s.mime || "video/mp4")}">`)
        .join("");

      return `
        <div class="vdt__promoMedia">
          <video class="vdt__promoVid" ${autoplay} ${muted} ${loop} playsinline preload="metadata" ${item.poster ? `poster="${safe(item.poster)}"` : ""}>
            ${sources}
          </video>
        </div>
        <div class="vdt__promoBody">
          <div class="vdt__promoKicker">Spotlight</div>
          <div class="vdt__promoTitle">${safe(heading)}</div>
          ${sub ? `<div class="vdt__promoSub">${safe(sub)}</div>` : ``}
          ${link ? `<a class="vdt__btn vdt__btn--primary vdt__promoCta" href="${safe(link)}" rel="noopener">${safe(cta)} <span aria-hidden="true">→</span></a>` : ``}
        </div>
      `;
    }

    if (item.type === "image") {
      return `
        <div class="vdt__promoMedia">
          <img class="vdt__promoImg" loading="lazy" decoding="async" src="${safe(item.image)}" alt="${safe(heading)}">
        </div>
        <div class="vdt__promoBody">
          <div class="vdt__promoKicker">Spotlight</div>
          <div class="vdt__promoTitle">${safe(heading)}</div>
          ${sub ? `<div class="vdt__promoSub">${safe(sub)}</div>` : ``}
          ${link ? `<a class="vdt__btn vdt__btn--primary vdt__promoCta" href="${safe(link)}" rel="noopener">${safe(cta)} <span aria-hidden="true">→</span></a>` : ``}
        </div>
      `;
    }

    if (item.type === "product" && item.product) {
      return `
        <div class="vdt__promoMedia">
          ${item.product.image ? `<img class="vdt__promoImg" loading="lazy" decoding="async" src="${safe(item.product.image)}" alt="${safe(item.product.title)}">` : `<div class="vdt__promoImg vdt__img--empty"></div>`}
        </div>
        <div class="vdt__promoBody">
          <div class="vdt__promoKicker">${safe(heading || "Volarre Pick")}</div>
          <div class="vdt__promoTitle">${safe(item.product.title)}</div>
          ${sub ? `<div class="vdt__promoSub">${safe(sub)}</div>` : ``}
          ${item.product.price ? `<div class="vdt__promoPrice">${safe(item.product.price)}</div>` : ``}
          <a class="vdt__btn vdt__btn--primary vdt__promoCta" href="${safe(item.product.url)}" rel="noopener">${safe(strip(item.cta) || "Shop")} <span aria-hidden="true">→</span></a>
        </div>
      `;
    }

    if (item.type === "ext") {
      const price = strip(item.price || "");
      const showPrice = price && price !== "—" && price !== "-";
      return `
        <div class="vdt__promoMedia">
          <img class="vdt__promoImg" loading="lazy" decoding="async" src="${safe(item.image)}" alt="${safe(heading)}">
        </div>
        <div class="vdt__promoBody">
          <div class="vdt__promoKicker">${safe(heading)}</div>
          ${sub ? `<div class="vdt__promoSub">${safe(sub)}</div>` : ``}
          ${showPrice ? `<div class="vdt__promoPrice">${safe(price)}</div>` : ``}
          ${item.url ? `<a class="vdt__btn vdt__btn--primary vdt__promoCta" href="${safe(item.url)}" rel="noopener" target="_blank">${safe(cta)} <span aria-hidden="true">→</span></a>` : ``}
        </div>
      `;
    }

    if (item.type === "ad") {
      const embedSafe = section.getAttribute("data-promo-embed-safe") === "true";
      const headingTxt = heading || "Partner";
      const subTxt = sub || "Sponsored.";
      const embed = item.embed || "";

      if (embedSafe) {
        const srcdoc = `
          <html><head><meta name="viewport" content="width=device-width,initial-scale=1"></head>
          <body style="margin:0; padding:0; font-family:system-ui;">${embed}</body></html>
        `.replace(/"/g, "&quot;");

        return `
          <div class="vdt__promoBody">
            <div class="vdt__promoKicker">${safe(headingTxt)}</div>
            <div class="vdt__promoSub">${safe(subTxt)}</div>
          </div>
          <div class="vdt__promoEmbed">
            <iframe title="${safe(headingTxt)}" sandbox="allow-forms allow-popups allow-same-origin" srcdoc="${srcdoc}"></iframe>
          </div>
        `;
      }

      return `
        <div class="vdt__promoBody">
          <div class="vdt__promoKicker">${safe(headingTxt)}</div>
          <div class="vdt__promoSub">${safe(subTxt)}</div>
        </div>
        <div class="vdt__promoEmbed vdt__promoEmbed--unsafe">
          ${embed}
        </div>
      `;
    }

    if (item.type === "video_url") {
      const href = item.video_url || "";
      return `
        <div class="vdt__promoMedia">
          ${item.poster ? `<img class="vdt__promoImg" loading="lazy" decoding="async" src="${safe(item.poster)}" alt="${safe(heading)}">` : `<div class="vdt__promoImg vdt__img--empty"></div>`}
          <div class="vdt__promoPlay">▶</div>
        </div>
        <div class="vdt__promoBody">
          <div class="vdt__promoKicker">Spotlight</div>
          <div class="vdt__promoTitle">${safe(heading)}</div>
          ${sub ? `<div class="vdt__promoSub">${safe(sub)}</div>` : ``}
          <a class="vdt__btn vdt__btn--primary vdt__promoCta" href="${safe(href)}" rel="noopener" target="_blank">${safe(cta)} <span aria-hidden="true">→</span></a>
        </div>
      `;
    }

    return "";
  }

  function promoTileHTML(section, items, fallbackCta) {
    const slides = items.map((it, idx) => {
      return `<div class="vdt__promoSlide" data-slide="${idx}">${promoCardInnerHTML(section, it, fallbackCta)}</div>`;
    }).join("");

    const dots = items.length > 1
      ? `<div class="vdt__promoDots" role="tablist" aria-label="Promos">
          ${items.map((_, i) => `<button class="vdt__promoDot ${i===0 ? "is-active" : ""}" type="button" aria-label="promo ${i+1}" data-dot="${i}"></button>`).join("")}
        </div>`
      : "";

    const nav = items.length > 1
      ? `<button class="vdt__promoNav vdt__promoNav--prev" type="button" aria-label="Previous">‹</button>
         <button class="vdt__promoNav vdt__promoNav--next" type="button" aria-label="Next">›</button>`
      : "";

    return `
      <article class="vdt__tile vdt__tile--promo">
        <div class="vdt__promoCarousel" data-promo-carousel="1">
          <div class="vdt__promoTrack">
            ${slides}
          </div>
          ${nav}
          ${dots}
        </div>
      </article>
    `;
  }

  function wirePromoCarousel(root) {
    const carousels = root.querySelectorAll('[data-promo-carousel="1"]');
    carousels.forEach(car => {
      const track = car.querySelector(".vdt__promoTrack");
      const slides = Array.from(car.querySelectorAll(".vdt__promoSlide"));
      const dots = Array.from(car.querySelectorAll(".vdt__promoDot"));
      const prev = car.querySelector(".vdt__promoNav--prev");
      const next = car.querySelector(".vdt__promoNav--next");
      if (!track || slides.length <= 1) return;

      let idx = 0;
      const set = (n) => {
        idx = Math.max(0, Math.min(slides.length - 1, n));
        track.style.transform = `translateX(${-idx * 100}%)`;
        dots.forEach((d, i) => d.classList.toggle("is-active", i === idx));
        slides.forEach((s, i) => {
          const v = s.querySelector("video");
          if (!v) return;
          if (i === idx) { try { v.play().catch(() => {}); } catch (_) {} }
          else { try { v.pause(); } catch (_) {} }
        });
      };

      prev && prev.addEventListener("click", () => set(idx - 1));
      next && next.addEventListener("click", () => set(idx + 1));
      dots.forEach(d => d.addEventListener("click", () => set(parseInt(d.dataset.dot || "0", 10))));

      // swipe (carousel only)
      let startX = 0, dx = 0, down = false;
      car.addEventListener("pointerdown", (e) => { down = true; startX = e.clientX; dx = 0; });
      car.addEventListener("pointermove", (e) => { if (!down) return; dx = e.clientX - startX; });
      car.addEventListener("pointerup", () => {
        if (!down) return;
        down = false;
        if (Math.abs(dx) > 40) set(idx + (dx < 0 ? 1 : -1));
        dx = 0;
      });

      set(0);
    });
  }

  function buildPlan(section, tabs, allArticles) {
    const cardsCount = parseInt(section.getAttribute("data-cards") || "14", 10);
    const refreshMode = section.getAttribute("data-refresh") || "daily";
    const key = periodKey(refreshMode);

    const pools = {};
    for (const t of tabs) {
      const wanted = parseTags(section.getAttribute(`data-tags-${t}`) || "");
      pools[t] = wanted.length ? allArticles.filter(a => a.tags.some(tag => wanted.includes(tag))) : allArticles.slice();
    }

    const used = new Set();
    const plan = {};

    for (const t of tabs) {
      const wanted = parseTags(section.getAttribute(`data-tags-${t}`) || "");
      const seed = `${key}::${section.getAttribute("data-section-id")}::${t}::${wanted.join("|")}`;
      const rnd = seededRand(seed);
      const shuffled = seededShuffle(pools[t] || [], rnd);

      plan[t] = [];
      for (const a of shuffled) {
        const id = String(a.id);
        if (used.has(id)) continue;
        used.add(id);
        plan[t].push(a);
        if (plan[t].length >= (cardsCount + 1)) break; // +1 includes feature
      }
    }

    return { key, plan };
  }

  function moreUrlForTab(section, tabKey) {
    const blogHandle = section.getAttribute("data-blog-handle") || "";
    const moreTag = section.getAttribute(`data-moretag-${tabKey}`) || "";
    if (!blogHandle || !moreTag) return "";
    return `/blogs/${encodeURIComponent(blogHandle)}/tagged/${encodeURIComponent(moreTag)}`;
  }

  function renderDesktopMasonry(section, tabKey, planObj, promoData) {
    const masonry = section.querySelector(`[data-masonry="${tabKey}"]`);
    if (!masonry) return;

    const items = (planObj && planObj.plan && planObj.plan[tabKey]) ? planObj.plan[tabKey] : [];
    const label = (section.querySelector(`${SEL.tab}[data-tab="${tabKey}"]`)?.textContent || tabKey).trim();

    if (!items.length) {
      masonry.innerHTML = `<div class="vdt__empty">No matches for this tab.</div>`;
      return;
    }

    const feature = items[0];
    const rack = items.slice(1);
    const mode = section.getAttribute("data-promo-mode") || (promoData.mode || "fill");
    const maxPromos = parseInt(section.getAttribute("data-promo-max") || promoData.max || "2", 10);
    const promoList = (mode === "off" || maxPromos <= 0) ? [] : promosForTab(section, promoData, tabKey).slice(0, Math.max(0, maxPromos));

    const leadPromos = promoList.slice(0, 2);
    const overflowPromos = promoList.slice(2);
    const promoStack = leadPromos.length
      ? `<div class="vdt__desktopPromoStack">${leadPromos.map(p => `<article class="vdt__tile vdt__tile--promo">${promoCardInnerHTML(section, p, promoData.defaultCta)}</article>`).join("")}</div>`
      : `<div class="vdt__desktopPromoStack">${rack.slice(0, 2).map(a => rackTileHTML(section, a, label)).join("")}</div>`;

    const rackOffset = leadPromos.length ? 0 : 2;
    const rackParts = [];
    overflowPromos.forEach(p => rackParts.push(promoTileHTML(section, [p], promoData.defaultCta)));
    rack.slice(rackOffset).forEach(a => rackParts.push(rackTileHTML(section, a, label)));

    const rem = rackParts.length % 4;
    const endcapSpan = rem ? (4 - rem) : 4;
    const rackClass = `vdt__desktopRack vdt__desktopRack--count-${rackParts.length}`;
    const endcap = vaultEndcapHTML(section, tabKey, label, endcapSpan);
    masonry.innerHTML = `<div class="vdt__desktopLead">${featureTileHTML(section, feature, label, tabKey)}${promoStack}</div><div class="${rackClass}">${rackParts.join("")}${endcap}</div>`;
    wirePromoCarousel(masonry);
    wireEndcaps(section, masonry);
  }

  function renderMobileShelf(section, tabKey, planObj, promoData) {
    const shelf = section.querySelector(`[data-shelf="${tabKey}"]`);
    if (!shelf) return;

    const items = (planObj && planObj.plan && planObj.plan[tabKey]) ? planObj.plan[tabKey] : [];
    const label = (section.querySelector(`${SEL.tab}[data-tab="${tabKey}"]`)?.textContent || tabKey).trim();

    if (!items.length) {
      shelf.innerHTML = ``;
      shelf.setAttribute("aria-hidden", "true");
      return;
    }

    const feature = items[0];
    const rest = items.slice(1, 13);
    const mode = section.getAttribute("data-promo-mode") || (promoData.mode || "fill");
    const promoList = (mode === "off") ? [] : promosForTab(section, promoData, tabKey).slice(0, 6);
    const promoRow = promoList.length
      ? `<div class="vdt__shelfPromos" aria-label="Swipe spotlights">${promoList.map(p => `<div class="vdt__shelfPromo">${promoCardInnerHTML(section, p, promoData.defaultCta)}</div>`).join("")}</div>`
      : ``;

    const PAGE = 4;
    const pages = [];
    for (let i = 0; i < rest.length; i += PAGE) {
      const chunk = rest.slice(i, i + PAGE);
      pages.push(`<div class="vdt__mobilePage" role="group" aria-label="Article set ${Math.floor(i / PAGE) + 1}">${chunk.map(a => rackTileHTML(section, a, label)).join("")}</div>`);
    }

    shelf.innerHTML = `<div class="vdt__shelfFeature">${featureTileHTML(section, feature, label, tabKey)}</div>${promoRow}<div class="vdt__mobilePages" aria-label="Swipe articles">${pages.join("")}</div>`;
    shelf.setAttribute("aria-hidden", "false");
  }

  function renderMoreCta(section, tabKey) {
    const wrap = section.querySelector(`[data-morewrap="${tabKey}"]`);
    const cta = section.querySelector(`[data-morecta="${tabKey}"]`);
    const label = (section.querySelector(`${SEL.tab}[data-tab="${tabKey}"]`)?.textContent || tabKey).trim();
    const href = moreUrlForTab(section, tabKey);
    const endcapHref = endcapUrlForTab(section, tabKey);

    if (!wrap || !cta || !href || (endcapHref && endcapHref === href)) {
      if (wrap) wrap.style.display = "none";
      return;
    }

    cta.href = href;
    cta.textContent = `All ${label}`;
    wrap.style.display = "";
  }

  function renderTab(section, tabKey, planObj, promoData) {
    renderDesktopMasonry(section, tabKey, planObj, promoData);
    renderMobileShelf(section, tabKey, planObj, promoData);
    renderMoreCta(section, tabKey);
  }

  function bind(section) {
    if (!section || section.dataset.vdtBound === "1") return;
    section.dataset.vdtBound = "1";

    const blogHandle = section.getAttribute("data-blog-handle");
    if (!blogHandle) { setStatus(section, "Select a Source blog in Customize."); return; }

    const promoData = getPromo(section);
    const tabs = Array.from(section.querySelectorAll(SEL.tab)).map(b => b.dataset.tab).filter(Boolean);

    setStatus(section, "Curating…");

    fetchAllArticles(blogHandle)
      .then((raw) => raw.map(normalizeArticle).filter(a => a.url && a.title))
      .then((all) => {
        if (!all.length) { setStatus(section, "No articles found in the selected blog."); return; }

        const planObj = buildPlan(section, tabs, all);
        section._vdtPlan = planObj;
        section._vdtPromo = promoData;

        const firstTab = tabs[0] || "food";
        renderTab(section, firstTab, planObj, promoData);
        setStatus(section, "");

        // click handler: NEVER block clicks (no pointer capture anywhere)
        section.querySelectorAll(SEL.tab).forEach(btn => {
          btn.addEventListener("click", () => {
            const tabKey = btn.dataset.tab;
            activateTab(section, tabKey);
            renderTab(section, tabKey, section._vdtPlan, section._vdtPromo);
          });
        });
      })
      .catch(() => setStatus(section, "Feed fetch failed. Check blog.vdt.json.liquid."));
  }

  function initAll(root = document) {
    root.querySelectorAll(SEL.section).forEach(bind);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initAll(document));
  } else {
    initAll(document);
  }

  document.addEventListener("shopify:section:load", (e) => {
    if (e && e.target) initAll(e.target);
    else initAll(document);
  });
})();